import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminMenu from "../../components/Layout/AdminMenu";
import Layout from "../../components/Layout/Layout";
import { useAuth } from "../../context/auth";
import moment from "moment";
import { Select } from "antd";
import "../../styles/AdminStyles.css";

const { Option } = Select;
const AdminOrders = () => {
  const statusList = [
    "Not Process",
    "Processing",
    "Shipped",
    "delivered",
    "cancelled",
  ];
  const [guestOrders, setGuestOrders] = useState([]);
  const [auth] = useAuth();

  const getGuestOrders = async () => {
    try {
      const { data } = await axios.get("/api/v1/orders/all-guest-orders");
      setGuestOrders(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token) getGuestOrders();
  }, [auth?.token]);

  const handleGuestStatusChange = async (orderId, value) => {
    try {
      await axios.put(`/api/v1/orders/guest-order-status/${orderId}`, {
        status: value,
      });
      getGuestOrders();
    } catch (error) {
      console.log(error);
    }
  };

  const getStatusLabel = (status) => {
    const map = {
      "Not Process": "قيد الانتظار",
      "Processing": "قيد المعالجة",
      "Shipped": "تم الشحن",
      "delivered": "تم التوصيل",
      "cancelled": "ملغي",
      // Legacy values for existing orders
      "deliverd": "تم التوصيل",
      "cancel": "ملغي",
    };
    return map[status] || status;
  };

  return (
    <Layout title={"جميع الطلبات - النخبة ستور"}>
      <div className="container-fluid admin-layout">
        <div className="row">
          <div className="col-md-3">
            <AdminMenu />
          </div>
          <div className="col-md-9">
            <div className="admin-page-header">
              <h1>إدارة الطلبات</h1>
              <p>طلبات العملاء المباشرة ({guestOrders?.length || 0} طلب)</p>
              <div className="admin-page-header-line"></div>
            </div>

            {guestOrders?.length > 0 ? (
              guestOrders?.map((o, i) => (
                <div className="admin-order-card" key={o._id} style={{animationDelay: `${i * 0.08}s`}}>
                  <div className="admin-order-header">
                    <div className="admin-order-header-item">
                      <span className="label">رقم الطلب</span>
                      <span className="value" style={{fontSize: '0.8rem'}}>{o.orderId}</span>
                    </div>
                    <div className="admin-order-header-item">
                      <span className="label">الحالة</span>
                      <Select
                        bordered={false}
                        onChange={(value) => handleGuestStatusChange(o._id, value)}
                        defaultValue={o?.status}
                        style={{minWidth: '140px'}}
                      >
                        {statusList.map((s, idx) => (
                          <Option key={idx} value={s}>{getStatusLabel(s)}</Option>
                        ))}
                      </Select>
                    </div>
                    <div className="admin-order-header-item">
                      <span className="label">العميل</span>
                      <span className="value">{o.name}</span>
                    </div>
                    <div className="admin-order-header-item">
                      <span className="label">الهاتف</span>
                      <span className="value">
                        <a href={`tel:${o.phone}`} style={{color: 'var(--gold-light)'}}>{o.phone}</a>
                      </span>
                    </div>
                    <div className="admin-order-header-item">
                      <span className="label">المحافظة</span>
                      <span className="value">{o.city}</span>
                    </div>
                    <div className="admin-order-header-item">
                      <span className="label">التاريخ</span>
                      <span className="value">{moment(o.createdAt).fromNow()}</span>
                    </div>
                  </div>

                  {/* Customer details */}
                  <div style={{padding: '12px 20px', borderBottom: '1px solid var(--glass-border)'}}>
                    <p style={{margin: '4px 0', color: 'var(--white-muted)', fontSize: '0.9rem'}}>
                      <strong style={{color: 'var(--gold)'}}>العنوان:</strong> {o.address}
                    </p>
                    {o.notes && (
                      <p style={{margin: '4px 0', color: 'var(--white-muted)', fontSize: '0.9rem'}}>
                        <strong style={{color: 'var(--gold)'}}>ملاحظات:</strong> {o.notes}
                      </p>
                    )}
                  </div>

                  {/* Products */}
                  <div className="admin-order-products">
                    {o?.products?.map((p, idx) => (
                      <div className="admin-order-product-row" key={idx}>
                        {p.productId && (
                          <img
                            src={`/api/v1/products/product-photo/${p.productId}`}
                            className="admin-order-product-img"
                            alt={p.name}
                            loading="lazy"
                          />
                        )}
                        <div className="admin-order-product-info">
                          <h6>{p.name}</h6>
                        </div>
                        <span className="admin-order-product-price">
                          {p.price?.toLocaleString("ar-IQ")} د.ع
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Total */}
                  <div style={{padding: '12px 20px', textAlign: 'left', borderTop: '1px solid var(--glass-border)'}}>
                    <strong style={{color: 'var(--gold)', fontSize: '1.1rem'}}>
                      المجموع: {o.total?.toLocaleString("ar-IQ")} د.ع
                    </strong>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state" style={{marginTop: '40px'}}>
                <div className="empty-state-icon">🧾</div>
                <h4>لا توجد طلبات</h4>
                <p>ستظهر الطلبات الجديدة هنا</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdminOrders;
